import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

export interface AddGebaeudeData {
  standortId: string;
}

@Component({
  selector: 'app-add-gebaeude-dialog',
  templateUrl: './add-gebaeude-dialog.component.html',
  styleUrls: ['./add-gebaeude-dialog.component.css'],
})
export class AddGebaeudeDialogComponent implements OnInit {
  frmGebaeude: UntypedFormGroup;
  standortId: string;

  constructor(
    public dialogRef: MatDialogRef<AddGebaeudeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddGebaeudeData,
    private _fb: UntypedFormBuilder
  ) {
    this.standortId = data.standortId;

    this.frmGebaeude = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      standort_id: [this.standortId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmGebaeude.valid) {
      this.dialogRef.close({ 
        event: 'create', 
        data: this.frmGebaeude.value 
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}

